import { Routes, Route, Navigate } from "react-router-dom";
import { CMFlex } from "@chartmetric/chartmetric-design-system/components/CMFlex";
import { CMI18nProvider, type CMI18nProviderProps } from "@chartmetric/chartmetric-design-system/providers/I18nProvider";
import { useTranslation } from "react-i18next";

import SiteHeader from "./components/SiteHeader";
import HomePage from "./pages/HomePage";
import PostDetailPage from "./pages/PostDetailPage";
import NotFoundPage from "./pages/NotFoundPage";
import AnnouncementServiceBridge from "./components/AnnouncementServiceBridge";
import SignInModal from "./components/SignInModal";
import LoginToast from "./components/LoginToast";

function App() {
  const { i18n } = useTranslation();

  return (
    <CMI18nProvider locale={i18n.language as CMI18nProviderProps["locale"]}>
    <AnnouncementServiceBridge>
      <CMFlex vertical background="bg-theme-background" height="min-h-screen">
        <SiteHeader />
        <main className="flex-1">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/dashboard" element={<Navigate to="/" replace />} />
            <Route path="/posts/:id" element={<PostDetailPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </main>
        <SignInModal />
        <LoginToast />
      </CMFlex>
    </AnnouncementServiceBridge>
    </CMI18nProvider>
  );
}

export default App;
